"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_code_blocks_1 = require("react-code-blocks");
const recharts_1 = require("recharts");
const CgpEvaluator_1 = require("./CgpEvaluator");
const CgpGenerator_1 = require("./CgpGenerator");
const CgpMutator_1 = __importDefault(require("./CgpMutator"));
exports.default = () => {
    const [generation, setGeneration] = React.useState(1);
    const [bestModel, setBestModel] = React.useState("");
    const [accuracy, setAccuracy] = React.useState(-1);
    const [fitnessData, setFitnessData] = React.useState([]);
    const MIDDLE_NODES = 20;
    const POOL_SIZE = 50;
    const [pool, setPool] = React.useState((0, CgpGenerator_1.generateCgpPool)(POOL_SIZE, 4, MIDDLE_NODES, 3));
    const [fitnesses, setFitnesses] = React.useState(Array(POOL_SIZE).fill(0));
    function getBest(localPool, localFit) {
        const fitActual = localFit.filter((value) => Number.isFinite(value));
        const bestIdx = localFit.indexOf(Math.max(...fitActual));
        return localPool[bestIdx];
    }
    function evaluateFitnesses(localPool) {
        return __awaiter(this, void 0, void 0, function* () {
            const fitnesses = yield Promise.all(localPool.map((prog) => {
                return (0, CgpEvaluator_1.evaluateProgramFitness)(prog, 4, MIDDLE_NODES, 3);
            }));
            return fitnesses;
            //setFitnesses(fitnesses);
        });
    }
    function mutatePool(localPool) {
        const newPool = localPool.map((prog) => {
            return (0, CgpMutator_1.default)(prog, 4, MIDDLE_NODES, 3);
        });
        return newPool;
        //setPool(newPool);
    }
    function runTournamentSelection(localPool, localFit) {
        const newPool = new Array();
        for (let i = 0; i < POOL_SIZE; i++) {
            const idxA = Math.floor(Math.random() * POOL_SIZE);
            const idxB = Math.floor(Math.random() * POOL_SIZE);
            if (localFit[idxA] > localFit[idxB]) {
                newPool.push(localPool[idxA]);
            }
            else {
                newPool.push(localPool[idxB]);
            }
        }
        return newPool;
    }
    return (React.createElement("div", null,
        React.createElement("p", null, "Now onto the next fun part. I would like to experiment with different ideas in genetic programming, and see how they compare to a \"base\" solution. For the comparison to be made though, we need some data on how well the base solution does, which means it's finally time to start bringing in a graphing library."),
        React.createElement("p", null, "This is the same code/problem as in the async post, but this time we're keeping track of the best and average fitness over generations using a recharts graph."),
        React.createElement(react_code_blocks_1.CodeBlock, { text: `Generation: ${generation}
Best model: ${bestModel}
Accuracy: ${accuracy}` }),
        React.createElement("button", { type: "button", onClick: (e) => __awaiter(void 0, void 0, void 0, function* () {
                const localPool = (0, CgpGenerator_1.generateCgpPool)(POOL_SIZE, 4, MIDDLE_NODES, 3);
                const localFit = yield evaluateFitnesses(localPool);
                // Find the best:
                const best = getBest(localPool, localFit);
                setAccuracy((0, CgpEvaluator_1.evaluateProgramAccuracy)(best, 4, MIDDLE_NODES, 3));
                setPool(localPool);
                setFitnesses(localFit);
                setGeneration(1);
                setBestModel(best);
                setFitnessData([]);
            }) }, "Reset Pool"),
        React.createElement("button", { type: "button", onClick: (e) => __awaiter(void 0, void 0, void 0, function* () {
                // Nice part is we already have the fitnesses:
                const newPool1 = runTournamentSelection(pool, fitnesses);
                const newPool2 = mutatePool(newPool1);
                const newFitnesses2 = yield evaluateFitnesses(newPool2);
                // Find the best:
                const best = getBest(newPool2, newFitnesses2);
                setAccuracy((0, CgpEvaluator_1.evaluateProgramAccuracy)(best, 4, MIDDLE_NODES, 3));
                setPool(newPool2);
                setFitnesses(newFitnesses2);
                setGeneration(generation + 1);
                setBestModel(best);
            }) }, "Run generation"),
        React.createElement("button", { type: "button", onClick: (e) => __awaiter(void 0, void 0, void 0, function* () {
                const curFitnessData = fitnessData;
                let curPool = pool;
                let curFitnesses = fitnesses;
                let curGeneration = generation;
                let i = 0;
                (function run() {
                    return __awaiter(this, void 0, void 0, function* () {
                        // Nice part is we already have the fitnesses:
                        const newPool1 = runTournamentSelection(curPool, curFitnesses);
                        curPool = mutatePool(newPool1);
                        curFitnesses = yield evaluateFitnesses(curPool);
                        // Find the best:
                        const best = getBest(curPool, curFitnesses);
                        const bestAccuracy = (0, CgpEvaluator_1.evaluateProgramAccuracy)(best, 4, MIDDLE_NODES, 3);
                        curGeneration = curGeneration + 1;
                        // Get our stats:
                        const fitActual = curFitnesses.filter((value) => Number.isFinite(value));
                        const fitnessData = {
                            generation: curGeneration,
                            bestAccuracy: bestAccuracy,
                            bestFitness: Math.max(...fitActual),
                            averageFitness: fitActual.reduce((a, b) => a + b) / fitActual.length,
                        };
                        curFitnessData.push(fitnessData);
                        setFitnessData(structuredClone(curFitnessData));
                        setAccuracy(bestAccuracy);
                        setPool(curPool);
                        setFitnesses(curFitnesses);
                        setGeneration(curGeneration);
                        setBestModel(best);
                        i++;
                        if (i < 100) {
                            setTimeout(run, 0);
                        }
                        else {
                            console.log(curFitnessData);
                        }
                    });
                })();
            }) }, "Run 100 generations"),
        React.createElement(recharts_1.LineChart, { width: 800, height: 500, data: fitnessData, margin: {
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
            } },
            React.createElement(recharts_1.CartesianGrid, { strokeDasharray: "3 3" }),
            React.createElement(recharts_1.XAxis, { dataKey: "generation" }),
            React.createElement(recharts_1.YAxis, { yAxisId: "left", label: {
                    value: "Accuracy",
                    angle: -90,
                    position: "left",
                    offset: 0,
                } }),
            React.createElement(recharts_1.YAxis, { yAxisId: "right", orientation: "right", label: {
                    value: "Fitness",
                    angle: 90,
                    position: "right",
                    offset: 0,
                } }),
            React.createElement(recharts_1.Tooltip, null),
            React.createElement(recharts_1.Legend, null),
            React.createElement(recharts_1.Line, { type: "monotone", yAxisId: "left", dataKey: "bestAccuracy", stroke: "#3F334D", activeDot: { r: 8 } }),
            React.createElement(recharts_1.Line, { type: "monotone", yAxisId: "right", dataKey: "bestFitness", stroke: "#C0C5C1" }),
            React.createElement(recharts_1.Line, { type: "monotone", yAxisId: "right", dataKey: "averageFitness", stroke: "#7D8491" }))));
};
